import { render, staticRenderFns } from "./PaginaSeleccionMuniPeriodoRevision.vue?vue&type=template&id=6616397e&lang=true"
import script from "./PaginaSeleccionMuniPeriodoRevision.vue?vue&type=script&lang=js"
export * from "./PaginaSeleccionMuniPeriodoRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports